import type { ProgressType } from '../../model/Challenge'
import type { ResolvedCheckpoint } from '../../logic/checkpointUtils'
import type { RouteCoordinate } from '../../logic/routeUtils'
import RmDotGrid from './RmDotGrid'
import RoutePreview from './RoutePreview'

interface ProgressGraphicProps {
  progressType: ProgressType
  teamProgress: number
  paceProgress: number
  goal: number
  checkpoints: ResolvedCheckpoint[]
  currentCheckpointId?: string
  routeCoordinates: RouteCoordinate[]
  height?: number
  dotColumns?: number
}

export default function ProgressGraphic({
  progressType,
  teamProgress,
  paceProgress,
  goal,
  checkpoints,
  currentCheckpointId,
  routeCoordinates,
  height,
  dotColumns,
}: ProgressGraphicProps) {
  if (progressType === 'dots') {
    return (
      <RmDotGrid
        progress={teamProgress}
        pace={paceProgress}
        goal={goal}
        checkpoints={checkpoints}
        currentCheckpointId={currentCheckpointId}
        columns={dotColumns}
      />
    )
  }

  return (
    <RoutePreview
      routeCoordinates={routeCoordinates}
      progress={teamProgress}
      totalDistance={goal}
      height={height}
    />
  )
}
